export const SET_ASSETS = "SET_ASSETS";
export const ADD_ASSET = "ADD_ASSET";
export const UPDATE_ASSET = "UPDATE_ASSET";
export const REMOVE_ASSET = "REMOVE_ASSET";
export const SET_USER_ASSETS = "SET_USER_ASSETS";
export const SET_RISK_ASSETS = "SET_RISK_ASSETS";
export const INFINTIE_ASSETS = "INFINTIE_ASSETS";
export const SET_SEARCHED_ASSET = "SET_SEARCHED_ASSET";
export const SET_ORGA_ASSETS = "SET_ORGA_ASSETS";
export const AVAILABLE_ASSETS = "AVAILABLE_ASSETS";
